// color code

const color_code = {
    Hot_Pink: "#ff4193",
    Dusty_Red: "#dc131e",
    Dusty_Pink: "#f03a42",
    Deep_Plum: "#b02066",
    Coral_De: "#ff686b",
    Bright_Pink: "#FF007F",
    Almond: "#f57d76",
    Spicy_Red: "#ea5f56",
    Rosewood: "#dd5e4c",
    Rose_Pink: "#ff8db8",
    Red_Wine: "#dd9a97",
    Poppy_Red: "#ff4e3c",
    Peach: "#fc8061",
    Intense_Copper: "#ea8472",
    Orange: "#ff7149",
    Deep_Red: "#c00e21",
    Caramel: "#c27764",
    Mocha: "#d87962",
    Delicate_Pink: "#cb8c80",
    Light_Pink_Purple: "#800080",
    Winter_Pink: "#ff7153",
    Watermelon: "#8d1f24",
    Super_Strawberry: "#a5331c",
    Pearly_Pink: "#d87881",
    Lady_Pink: "#dc7b84",
    Hazelnut: "#9e393f",
    Almond_Brown: "#bb5049",
    Shocking_Pink: "#f962ae",
    Red_Rose: "#fa62ae",
    Red_Glitter: "#f74f55",
    Plum: "#da91a7",
    Pearl: "#f5b8c1",
    Light_Beige_Glitter: "#fab091",
    Dark_Peach: "#dc7a7f",
    Cherry_Red: "#ea4d3d",
    Bronze: "#e29a73",
    Transparent_Shine: "#fefbf9",
    Gunmetal: "#5f6670",
    Golden_Honey: "#A89256",
    Dusty_Pink_Satin: "#C9AEA5",
    Diamond_Stardust: "#A0938C",
    Deep_Brown: "#674c45",
    Dark_Olive_Green: "#464a37",
    Coral_Pink: "#8f505c",
    Copper_Satin: "#c0baae",
    Coconut_Shell: "#554b4b",
    Brown_Gray: "#8f7a6b",
    Black_Onyx: "#3d3b3c",
    Yellow_Lime: "#6d6437",
    Ultraviolet: "#6f4a80",
    Silver_Gray: "#8c8f91",
    Porcelain_White: "#decebf",
    Pearl_White: "#eae0c8",
    Mocha_Satin: "#473031",
    Mint_Green: "#3f5a51",
    Marine_Blue: "#385164",
    Light_Taupe: "#754b34",
    Light_Brown_Pink: "#FFC0CB",
    Light_Blue: "#7fa4c1",
    Ivory: "#e0bfa3",
    Pink: "#ffc0cb",
    Peach_Mousse: "#dac4a7",
    Light_Gold: "#a0826f",
    Grape_Flavor: "#875c7e",
    Champagne_Rose: "#b98e81",
    Sky: "#87ceeb",
    Brown: "#593f3c",
    Deep_Blue: "#153657",
    White: "#FFFFFF",
    Black: "#000000",
    Blue_Ocean: "#4F42B5",
    Golden_Sunset: "#e38a2f",
    Olive_Tree: "#afa54b",
    Pure_Gold: "#cea28b",
    Dark_Gold: "#e9a584",
    Gold:"#d4af37",
    Green:"#00ff00",
    Black:"#000000",
    Red	:"#ff4500"
}


$(document).ready(function(){ 
    setTimeout(function(){
        $(".os_categoryFilterLinks li").each(function(){
            if($(this).find('a').hasClass("sort-by-selected-active")) {
                console.log('this is the end');
                $(".os_categoryFilterLinks li").find('a').last().removeClass("sort-by-selected-active-second");
            }
        })
    },100);

    $('.need-help').on('click',function(){
        $('.crisp-kquevr').attr('data-maximized','true');
        $('.crisp-ewasyx').attr('data-visible','true');
        $('.crisp-kquevr').trigger('click');
        $('.crisp-kquevr').attr('data-maximized','true');
        $('.crisp-1ekhg1c').on('click',function(){
            $('.crisp-kquevr').attr('data-maximized','false');
            $('.crisp-ewasyx').attr('data-visible','false');
            console.log('reaching here for chat box');
        });
    });

    setTimeout(function(){
        $("#js-tabs-bestseller-link").trigger('click');
    },500)

    console.log($('.get-info').attr("data"));

    $('.child-linking-offers').hover( 
        function(){
           $('.hovered-navigation-list').css({"display":"none"});
           var a = $(this).attr('link-name');
           console.log($(this).attr('link-name'));
           var b = a+"-link";
           console.log('b is '+b);
           $("."+b+"").css({"display":"block"});
           $(".hamburger-overlay").css({"display":"block","z-index":"-1"});
           $(this).find('.offers-link').addClass('offers-link-hover');
        //    $('.mega-menu-overlay').css({'cssText':'display: block !important'});
        },
        function(){
            var a = $(this).attr('link-name');
            console.log($(this).attr('link-name'));
            var b = a+"-link";
            $('.hovered-navigation-list').css({"display":"none"});
            $(".hamburger-overlay").css({"display":"none"});
            $(this).find('.offers-link').removeClass('offers-link-hover');
            console.log('b is gone '+b);
            // $('.mega-menu-overlay').css({'cssText':'display: none !important'});
        }
    ); 

    if ($(window).width() < 1199) { 
        $('.footer-headings-container').on('click',function(){
            // console.log('this is Mayank');
            // var a = $(this);
            if($(this).siblings().css("visibility") == "visible"){
                console.log('this is Mayank2');
                // console.log('this one is visible');
                // a.siblings().attr({"height":"0px","visibility":"hidden"});
                $('.footer-links-container').each(function(){
                    $(this).css({"height":"0px","visibility":"hidden"});
                });
                $('.footer-headings-container').each(function(){
                    // $(this).find('.fuse_down_arrow').css({"transform":"rotate(0deg)"});
                    $(this).find('.minus_symbol').css({"display":"none"});
                    $(this).find('.plus_symbol').css({"display":"block"});
                });
            }
            else{
                $('.footer-links-container').each(function(){
                    $(this).css({"height":"0px","visibility":"hidden"});
                });
                $('.footer-headings-container').each(function(){
                    // $(this).find('.fuse_down_arrow').css({"transform":"rotate(0deg)"});
                    $(this).find('.minus_symbol').css({"display":"none"});
                    $(this).find('.plus_symbol').css({"display":"block"});
                });
                $(this).siblings().css({"height":"auto","visibility":"visible"});
                // $(this).find('.fuse_down_arrow').css({"transform":"rotate(180deg)"});
                $(this).find('.minus_symbol').css({"display":"block"});
                $(this).find('.plus_symbol').css({"display":"none"});
            }
        });
    }
    // if($('.instagram-section').hasClass('.fs-wide-timeline')){
    //     $('.loading-image').css({"display":"none"});
    //     $('.loading-content').css({"display":"block"});
    // }
    // $('.fs-wide-timeline').load(function(){

    // });

    //on page load highlight the first variant with images and color active
    $('.color-div:first-child').addClass('active');
    $('.quantity-div:first-child').addClass('active');
    if($('.color-div').length > 0){
        variant_id = $('.color-div:first-child').attr('value');
        console.log('this is not a single product');
        console.log('variant_id '+variant_id);
    }
    else if($('.quantity-div').length > 0){
        variant_id = $('.quantity-div:first-child').attr('value');
        console.log('variant_id '+variant_id);
    }
    // else if($('.js-add-to-cart').hasAttr('data-variant-id')){
    //     variant_id = $('.js-add-to-cart').attr('data-variant-id');
    //     console.log('this is a single product');
    //     console.log('variant_id '+variant_id);
    // }
    else{
        console.log('This is empty else'); 
    }

    // var attrCheck = $('.js-add-to-cart').attr('data-variant-id');
    // // console.log($('.js-add-to-cart').hasAttr('data-variant-id'));

    // if(typeof attrCheck !== typeof undefined && attrCheck !== false){
    //     variant_id = $('.js-add-to-cart').attr('data-variant-id');
    //     console.log('this is a single product');
    //     console.log('variant_id '+variant_id);
    // }

    console.log($('.single-image-container-outer').first().find('.product-featured-img').attr("alt"));
    
    $('.product-images-container .single-image-container-outer').each(function(){
        console.log($(this).find('.product-featured-img').attr("alt") == $('.single-image-container-outer').first().find('.product-featured-img').attr("alt"));
        if($(this).find('.product-featured-img').attr("alt") == $('.single-image-container-outer').first().find('.product-featured-img').attr("alt")){
            $(this).closest('.single-image-container-outer').css({"display":"block"});
        }
        else {
            $(this).closest('.single-image-container-outer').css({"display":"none"});
        }
    });
    $('.bags-image-container-mobile .single-image-container-outer:visible:not(:eq(0))').css({"display":"none"});

    // $('.product-images-container-mobile .single-image-container-outer-mobile').each(function(){
    //     console.log($(this).find('.product-featured-img').attr("alt") == $('.single-image-container-outer-mobile').first().find('.product-featured-img').attr("alt"));
    //     if($(this).find('.product-featured-img').attr("alt") == $('.single-image-container-outer-mobile').first().find('.product-featured-img').attr("alt")){
    //         $(this).closest('.single-image-container-outer-mobile').css({"display":"block"});
    //         console.log('reaching in mobile product page carousel');
    //     }
    //     else{
    //         $(this).closest('.single-image-container-outer-mobile').css({"display":"none"});
    //         console.log('not not reaching in mobile product page carousel');
    //     }
    // });

    //price of variant at the time of page load
    $('.product-price').first().addClass('active');
    $('.product-mrp').first().addClass('active');
    $('.product-discount-percentage').first().addClass('active');
    $('.product-price:first-child').addClass('active');
    $('#satcb_price, .product-mrp').eq(1).addClass('active');
    $('#satcb_price, .product-discount-percentage').eq(1).addClass('active');
    $('.carousel-section').first().addClass('active');
    $('.mobile-carousel-links').first().addClass('active');
    $('.mobile-carousel-links-item').first().addClass('active');

    //color picker classes dynamically
    function getClassStartsWith(t,n){var r=$.grep(t.split(" "),function(t,r){return 0===t.indexOf(n)}).join();return r||!1}

    $('.color-picker-variant').each(function(){
        // if($('.color-picker-variant[class^="#"]')){
        //     // console.log($(this).attr('class'));
        //     var $element = $(this);
        //     var classes = $element[0].className;
        //     var getHeight = getClassStartsWith(classes,'#');
        //     $(this).css({"background-color":getHeight});   
        // }
        // var current_color = $(this).attr('color');
        // $(this).css({"background-color":color_code[current_color]});
    });


    var positionToScroll = $(".policy_left_align .active").position().left - 15;

    $(".policy_left_align").scrollLeft(positionToScroll);
 
});






// ============== this is for adding the type product in search page url =============
var pageURL = window.location.href;
var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);
var lastURLSegmentAmpersand = pageURL.substr(pageURL.lastIndexOf('&') + 1);
console.log(lastURLSegment.slice(0,6));
console.log(lastURLSegmentAmpersand);
if(lastURLSegment.slice(0,6) == "search" && lastURLSegmentAmpersand != "type=product"){
    window.location = pageURL + '&type=product';
}
// ===================== search page url ends ====================

$( window ).on("load", function() { 

    // Handler for .load() called.
  // $(".slick-active").find('button').trigger('click');
    $('.color-picker-variant').first().trigger('click');
    //$('.js-home-banner-carousel .slick-active').first().trigger('click');

    // var pageURL = window.location.href;
    // var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);
    // var lastURLSegmentAmpersand = pageURL.substr(pageURL.lastIndexOf('&') + 1);
    // console.log(lastURLSegment.slice(0,6));
    // console.log(lastURLSegmentAmpersand);
    // if(lastURLSegment.slice(0,6) == "search" && lastURLSegmentAmpersand != "type=product"){
    //     window.location = pageURL + '&type=product';
    // } 
});

$('.tablet-hamburger').click(function(){
    $('.tablet-and-mobile-navigation').css({"display":"block","transition":"width 5s ease"});
    console.log('reaching here hamburder open');
    $('.product-form__controls-group').css({"display":"none"});
    $(".hamburger-overlay").css({"display":"block"});
    $("body").css({"overflow":"hidden","position":"relative"});
    $('.tablet-hamburger-links').addClass('collapsed');
    // $('main section').css({"filter":"blur(10px)"});
    $('.sca-body-currency').css({"display":"none"});
    $('.weglot-container').addClass('weglot-display');
});

$('.close_btn').click(function(){
    $('.tablet-and-mobile-navigation, .hamburger-overlay').hide();
    $("body").css({"overflow":"auto"}); 
    $('.product-form__controls-group').css({"display":"block"});
    console.log('reaching here in clode button');
});

$('.close-btn-child-list').click(function(){
    $('.tablet-navigation').css({"transform":"translateX(0%)"});
    $('.tablet-and-mobile-navigation, .hamburger-overlay').hide();
    $("body").css({"overflow":"auto"}); 
    $('.product-form__controls-group').css({"display":"block"});
    $('.mobile-seach').css({"display":"block"});
    $('.close-btn-parent-list').css({"display":"block"});
});

$('.question').on('click',function(){
    if($('.clicked-delivery-details-container').hasClass('active')){
        $('.clicked-delivery-details-container').removeClass('active');
    }
    else{
        $('.clicked-delivery-details-container').addClass('active');
    }
    // $('.clicked-delivery-details-container').css({"display":"block"});
    // console.log('Reaching here in time');
});

const $menu = $('.clicked-delivery-details-container');

$(document).mouseup(e => {
   if (!$menu.is(e.target) // if the target of the click isn't the container...
   && $menu.has(e.target).length === 0) // ... nor a descendant of the container
   {
     $menu.removeClass('active');
  }
 });

$('.toggle').on('click', () => {
  $menu.toggleClass('is-active');
});

$('.hamburger-overlay').click(function(){
    $('.tablet-and-mobile-navigation').css({"display":"none"});
    console.log('reaching here hamburder overlay');
    $('.product-form__controls-group').css({"display":"block"});
    $(".hamburger-overlay").css({"display":"none"});
    $('.search-container').css({"display":"none"});
    $("body").css({"overflow":"auto"});
    // $('main section').css({"filter":"blur(10px)"});
    $('.sca-body-currency').css({"display":"inline-block"});
    $('.weglot-container').removeClass('weglot-display');
});

$('.tablet-and-mobile-navigation .tablet-hamburger-links').on('click',function(){
    if($(this).hasClass('collapsed')){
        // $(this).find('img').css({"transform":"rotate(0deg)"});
        console.log('reaching here in collapse p removed');
        console.log($(this).closest('.down-arrow-hamburger-display').find('img'));
        // $('.tablet-navigation').css({"transform":"translateX(-100%)"});
    }
    else{
        // $(this).find('img').css({"transform":"rotate(-90deg)"});
        console.log('reaching here in collapse 2');
    }
});

$('.tablet-and-mobile-navigation .js-tablet-navigation-upper .tablet-hamburger-links').on('click',function(){
    if ($(this).attr('data-target')) {
        $('.tablet-navigation').css({"transform": "translateX(-100%)"});
        $('.mobile-seach').css({"display": "none"});
        $('.close-btn-parent-list').css({"display": "none"});
        $('.shop-list-hamburger-absolute').addClass('activeImportant');
    }
});

$('.back-parent-list').on('click',function(){
    $('.tablet-navigation').css({"transform": "translateX(0%)"});
    $('.mobile-seach').css({"display": "block"});
    $('.close-btn-parent-list').css({"display": "block"});
});

$('.tablet-and-mobile-navigation .child-tablet-hamburger-links').on('click',function(){
    if(!$(this).hasClass('collapsed')){
        // $(this).find('img').css({"transform":"rotate(-90deg)"});
        console.log('reaching here in collapse p removed');
        console.log($(this).closest('.down-arrow-hamburger-display').find('img'));
    }
    else{
        // $(this).find('img').css({"transform":"rotate(0deg)"});
        console.log('reaching here in collapse 2');
    }
});

// $(document).mouseup(function (e){
//     var container = $(".tablet-and-mobile-navigation"); 
//       if(!container.is(e.target) && container.has(e.target).length === 0) {
//           container.hide();
//           $(".hamburger-overlay").css({"display":"none"});
//           $("body").css({"overflow":"auto"});
//       }
// });

$('.search-icon-container').click(function(){
    $('.search-container').css({"display":"block"});
    $(".hamburger-overlay").css({"display":"block"});
    $("body").css({"overflow":"hidden"});
    $('.search-container input').focus();
    $('.search-container input').val('');
    $('.announcement-bar-section  .sca-body-currency').css({"z-index":"8"});
    // $('main section').css({"filter":"blur(10px)"});
});

$('.cancel-search').click(function(){
    $('.search-container').css({"display":"none"});
    $(".hamburger-overlay").css({"display":"none"});
    $("body").css({"overflow":"auto"});
    $('.announcement-bar-section  .sca-body-currency').css({"z-index":"11"});
    // $('main section').css({"filter":"blur(10px)"});
});

$('.hamburger-overlay').on('click',function(){
    $('.tablet-and-mobile-navigation').css({"display":"none"});
    $(".hamburger-overlay").css({"display":"none"});
    $("body").css({"overflow":"auto","position":"static"});
    $('.announcement-bar-section  .sca-body-currency').css({"z-index":"11"});
});

// $('.tablet-hamburger').click(function(){
//     $('.tablet-and-mobile-navigation').css({"display":"block","transition":"width 5s ease"});
//     console.log('reaching here hamburder');
//     $(".hamburger-overlay").css({"display":"block"});
//     $("body").css({"overflow":"hidden","position":"relative"});
//     // $('main section').css({"filter":"blur(10px)"});
// });

// $(document).click(function (e){
//     var container = $(".search-container *"); 
//       if(!container.is(e.target) && container.has(e.target).length === 0) {
//           container.hide();
//           $(".hamburger-overlay").css({"display":"none"});
//           $("body").css({"overflow":"auto"});
//       }
// });


$('.js-about-us-science-behind-fuse').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    prevArrow:'<button type="button" class="slick-arrow slick-arrow--prev-men pull-left"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="32.092" height="62.771" viewBox="0 0 32.092 62.771"><path id="Path_6971" data-name="Path 6971" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(8569.738 5453.231) rotate(180)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    nextArrow:'<button type="button" class="slick-arrow slick-arrow--next-men pull-right"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="32.092" height="62.771" viewBox="0 0 32.092 62.771"><path id="Path_6472" data-name="Path 6472" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(-8537.646 -5390.46)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
});



// $('.country-code-select').selectric({
    // disableOnMobile: false,
    // nativeOnMobile: false,
    // openOnHover: true,
    // hoverIntentTimeout: 100,

// });

$('.men-carousel-section').hover( 
    function(){
        $('.slick-arrow--prev-men').addClass("active");
        $('.slick-arrow--next-men').addClass("active");
    },
    function(){
        $('.slick-arrow--prev-men').removeClass("active");
        $('.slick-arrow--next-men').removeClass("active");
    }
)

$(".bestseller-link-container .best-seller-links").on("click", function() {
    $(".best-seller-links").removeClass("active");
    $(this).addClass("active");
    let clickedTabIndex = $(this).index();
    console.log(clickedTabIndex);
    $(".tabs-bestseller").removeClass("active");
    $(".tabs-bestseller").eq(clickedTabIndex).addClass("active");
    console.log('this is reaching here');
}); 

$(".best-seller-links").first().addClass('active');

$('#js-tabs-bestseller-link').on('click',function(){
    $('#js-tabs-bestseller').css({"display":"block"});
    $('#js-tabs-soclean').css({"display":"none"});
    $('#js-tabs-cpap').css({"display":"none"});
});

$('#js-tabs-soclean-link').on('click',function(){
    $('#js-tabs-bestseller').css({"display":"none"});
    $('#js-tabs-soclean').css({"display":"block"});
    $('#js-tabs-cpap').css({"display":"none"});
});

$('#js-tabs-cpap-link').on('click',function(){
    $('#js-tabs-bestseller').css({"display":"none"});
    $('#js-tabs-soclean').css({"display":"none"});
    $('#js-tabs-cpap').css({"display":"block"});
});

$('.view-similar').hover(
    function(e){
        e.stopPropagation();
        $('.view-similar-span').css({"display": "inline-block","width": "auto","height": "auto","padding-left":"25px","visibility": "visible"});
    },
    function(e){
        e.stopPropagation();
        $('.view-similar-span').css({"display": "inline-block","width": "0px","height": "0px","padding-left":"0px","visibility": "hidden"});
    }
)

$('#shop-by-carousel').slick({
    slidesToShow: 3,
    dots:true,
    prevArrow:'<button type="button" class="slick-arrow slick-arrow--prev pull-left"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="32.092" height="62.771" viewBox="0 0 32.092 62.771"><path id="Path_6971" data-name="Path 6971" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(8569.738 5453.231) rotate(180)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    nextArrow:'<button type="button" class="slick-arrow slick-arrow--next pull-right"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="32.092" height="62.771" viewBox="0 0 32.092 62.771"><path id="Path_6472" data-name="Path 6472" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(-8537.646 -5390.46)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            rtl:false,
          }
        }
    ]
});

// $('.product-images-container-mobile').slick({ 
//     slidesToShow: 1,
//     dots:true,
//     arrows:false
// });

$('.faq-heading-container').on('click',function(){
    $('.faq-single').each(function(){
        // $(this).find('.faq_arrow').css({"transform":"rotate(0deg)"});
        $(this).find('.plus-symbol').css({"display":"block"});
        $(this).find('.minus-symbol').css({"display":"none"});
    }); 
    if($(this).parent().hasClass( "collapsed")){
        // $(this).find('.faq_arrow').css({"transform":"rotate(45deg)"});
        $(this).find('.plus-symbol').css({"display":"none"});
        $(this).find('.minus-symbol').css({"display":"block"});
    }
    else{
        // $(this).find('.faq_arrow').css({"transform":"rotate(0deg)"});
        $(this).find('.plus-symbol').css({"display":"block"});
        $(this).find('.minus-symbol').css({"display":"none"});
    }   
});


$('.color-picker-variant').on('click',function(){
    // console.log($(this).attr('color'));
    variant_id = $(this).attr('value');
    // console.log(variant_id);
    var a = $(this).attr('color');
    var b = "this is "+a+" tag";
    // console.log(a);
    // console.log(b);
    // console.log($('.single-image-container-inner .product-featured-img').attr(b));

    //color box border highlight
    $('.color-div').each(function(){
        $(this).removeClass('active');
    });
    $(this).addClass('active');

    //price of the variant display
    $('.product-price').each(function(){
        $(this).removeClass('active');
        if($(this).attr('price-variant-id') == variant_id){
            $(this).addClass('active');
        }
    });

    //mrp of the variant display
    $('.product-mrp').each(function(){
        $(this).removeClass('active');
        if($(this).attr('mrp-variant-id') == variant_id){
            $(this).addClass('active');
        }
    });

    //Discount of the variant display
    $('.product-discount-percentage').each(function(){
        $(this).removeClass('active');
        if($(this).attr('discount-variant-id') == variant_id){
            $(this).addClass('active');
        }
    });

    // $('.quantity-variant-inventry').each(function(){
    //     $(this).removeClass('active');
    //     if($(this).attr('variant-inventry-id') == variant_id){
    //         $(this).addClass('active');
    //     }
    // });    

    $('.product-images-container .single-image-container-outer').each(function(){
        // console.log($(this).find('.product-featured-img').attr("alt") == b);
        // console.log($(this).find('.product-featured-img').attr("alt"));
        if($(this).find('.product-featured-img').attr("alt") == b){
            $(this).closest('.single-image-container-outer').css({"display":"block"});
        }
        else{
            $(this).closest('.single-image-container-outer').css({"display":"none"});
        }
    });

    $('.product-images-container-mobile .mobile-carousel-links-item').each(function(){
        // console.log($(this).find('.product-featured-img').attr("alt") == b);
        // console.log($(this).find('.product-featured-img').attr("alt"));
        // if($('.color-picker-variant[class^="#"]')){
        //     // console.log($(this).attr('class'));
        //     var $element = $(this);
        //     var classes = $element[0].className;
        //     var getHeight = getClassStartsWith(classes,'#');
        //     console.log('thios is '+getHeight);
        //     $(this).css({"background-color":"block"});   
        // }
        // else{
        //     $(this).css({"background-color":"none"}); 
        // }
        if($(this).find('.product-featured-img').attr("alt") == b){
            $(this).closest('.mobile-carousel-links-item').addClass('mobile-carousel-links-item-active');
        }   
        else{
            $(this).closest('.mobile-carousel-links-item').removeClass('mobile-carousel-links-item-active');
        }
    });
    $('.bags-image-container-mobile .single-image-container-outer:visible:not(:eq(0))').css({"display":"none"});


    $('.carousel-bags-container-dots').empty();
    $('.carousel-bags-container .bags-image-container-mobile').each(function(index){
        // console.log($(this).attr('class'));
        var colorClass = b.replace(/ /g,'');
        // dotCount = 0;
        // console.log('b inside carousel bags '+b.replace(/ /g,''));
        // console.log('Has class '+$(this).hasClass(colorClass));
        if($(this).hasClass(colorClass)){
            $(this).css({"display":"block"});
            $(this).addClass('index'+index)
            $('.carousel-bags-container-dots').append('<div class="dots-bags indexof'+index+'"></div>');
        }
        else{
            $(this).css({"display":"none"});
        }

        if($('.product-featured-img:visible')){
            // console.log('this is visible jquery');
        }
    });
    
});

// =================== swipe detection in mobile ===================
class SwipeEventDispatcher {
    constructor(element, options = {}) {
        this.evtMap = {
            SWIPE_LEFT: [],
            SWIPE_UP: [],
            SWIPE_DOWN: [],
            SWIPE_RIGHT: []
        };

        this.xDown = null;
        this.yDown = null;
        this.element = element;
        this.isMouseDown = false;
        this.listenForMouseEvents = true;
        this.options = Object.assign({ triggerPercent: 0.3 }, options);

        element.addEventListener('touchstart', evt => this.handleTouchStart(evt), false);
        element.addEventListener('touchend', evt => this.handleTouchEnd(evt), false);
        element.addEventListener('mousedown', evt => this.handleMouseDown(evt), false);
        element.addEventListener('mouseup', evt => this.handleMouseUp(evt), false);
    }

    on(evt, cb) {
        this.evtMap[evt].push(cb);
    }

    off(evt, lcb) {
        this.evtMap[evt] = this.evtMap[evt].filter(cb => cb !== lcb);
    }

    trigger(evt, data) {
        this.evtMap[evt].map(handler => handler(data));
    }

    handleTouchStart(evt) {
        this.xDown = evt.touches[0].clientX;
        this.yDown = evt.touches[0].clientY;
    }

    handleMouseDown(evt) {
        if (this.listenForMouseEvents==false) return;
        this.xDown = evt.clientX;
        this.yDown = evt.clientY;
        this.isMouseDown = true;
    }

    handleMouseUp(evt) {
        if (this.isMouseDown == false) return;
        const deltaX = evt.clientX - this.xDown;
        const deltaY = evt.clientY - this.yDown;
        const distMoved = Math.abs(Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY);
        const activePct = distMoved / this.element.offsetWidth;

        if (activePct > this.options.triggerPercent) {
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                deltaX < 0 ? this.trigger('SWIPE_LEFT') : this.trigger('SWIPE_RIGHT');
            } else {
                deltaY > 0 ? this.trigger('SWIPE_UP') : this.trigger('SWIPE_DOWN');
            }
        }
    }

    handleTouchEnd(evt) {
        const deltaX = evt.changedTouches[0].clientX - this.xDown;
        const deltaY = evt.changedTouches[0].clientY - this.yDown;
        const distMoved = Math.abs(Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY);
        const activePct = distMoved / this.element.offsetWidth;

        if (activePct > this.options.triggerPercent) {
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                deltaX < 0 ? this.trigger('SWIPE_LEFT') : this.trigger('SWIPE_RIGHT');
            } else {
                deltaY > 0 ? this.trigger('SWIPE_UP') : this.trigger('SWIPE_DOWN');
            }
        }
    }
}

// add a listener on load
window.addEventListener("load", function(event) {
    var scrollWidth = $(window).width();
    var add = 0;
    var addMax = $('.dots-bags').length;
    $('.dots-bags').first().addClass('active');
    console.log('Max add length is '+addMax);
    const dispatcher = new SwipeEventDispatcher(document.body);
    dispatcher.on('SWIPE_RIGHT', () => { 
        console.log('I swiped right!');
        // add -= scrollWidth;
        // console.log(add);
        
        // this.document.getElementById('carousel-bags-container-mobile').scrollTo(add,0);
       
        // console.log(scrollImages);
        // console.log('Max add length is '+addMax);
        // var scrollWidthPercentage = (add/$(window).width())*100;
        // console.log(add);
        // console.log('right'+scrollWidthPercentage);
        if(add > 0){
            add--;
            scrollImages = add*100;

            $('.dots-bags').each(function(){
                $(this).removeClass('active');
                
            });
            $('.dots-bags:eq('+add+')').addClass('active');

            $('.bags-image-container-mobile').css({"transform":"translate(-"+scrollImages+"%)"});
        }
    })
    dispatcher.on('SWIPE_LEFT', () => { 
        console.log('I swiped left!'); 
        // add += scrollWidth;
        // console.log(add);

        // console.log(scrollImages);
        // console.log('Max add length is '+addMax);
        // this.document.getElementById('carousel-bags-container-mobile').scrollTo(add,0);
        // add += scrollWidth;
        // console.log(add);
        // var scrollWidthPercentage = (add/$(window).width())*100;
        // console.log('left'+scrollWidthPercentage);
        if( add < addMax -1 ){
            add++;
            scrollImages = add*100;
        //             console.log(scrollImages);
        // console.log('Max add length is '+addMax);
            
            $('.dots-bags').each(function(){
                $(this).removeClass('active');
                
            });
            $('.dots-bags:eq('+add+')').addClass('active');
            $('.bags-image-container-mobile').css({"transform":"translate(-"+scrollImages+"%)"});
        }
    })
});                     


// =================== swipe detection in mobile ends ===================

$('.dots-bags').first().addClass('active');

$('.quantity-picker-variant').on('click',function(){
    console.log($(this).attr('quantity'));
    variant_id = $(this).attr('value');
    console.log(variant_id);
    // var a = $(this).attr('quantity');
    // var b = "this is "+a+" tag";
    // console.log(a);
    // console.log(b);
    // console.log($('.single-image-container-inner .product-featured-img').attr(b));

    // //quantity box border highlight
    $('.quantity-div').each(function(){
        $(this).removeClass('active');
    });
    $(this).addClass('active');

    //price of the variant display
    $('.product-price').each(function(){
        $(this).removeClass('active');
        if($(this).attr('price-variant-id') == variant_id){
            $(this).addClass('active');
        }
    });

    //mrp of the variant display
    $('.product-mrp').each(function(){
        $(this).removeClass('active');
        if($(this).attr('mrp-variant-id') == variant_id){
            $(this).addClass('active');
        }
    });

    //Discount of the variant display
    $('.product-discount-percentage').each(function(){
        $(this).removeClass('active');
        if($(this).attr('discount-variant-id') == variant_id){
            $(this).addClass('active');
        }
    });


    // $('.single-image-container-outer').css({"display":"none"});
    // $('.product-images-container .single-image-container-outer').each(function(){
    //     console.log($(this).find('.product-featured-img').attr("alt") == b);
    //     if($(this).find('.product-featured-img').attr("alt") == b){
    //         $(this).closest('.single-image-container-outer').css({"display":"block"});
    //     }
    //     else{
    //         $(this).closest('.single-image-container-outer').css({"display":"none"});
    //     }
    // });
});


// store locator page slick carousel
$('.image-carousel').slick({
    arrows: false,
    dots: true
});

$(".js-icon-quantity-product").on("click", function() {
    // console.log($(this));
    // let updatedQuantityVal = 0;
    // let currentQuantityVal = Number($(this).closest("span").siblings(".product-page__quantity-input").val());
    // console.log(typeof currentQuantityVal);
    var count = parseInt($('#Quantity_product').val());
    if($(this).hasClass("js-icon-plus-product")) {
        count = count + 1;
        $('#Quantity_product').val(count);
        // console.log('plus clicked');
        // if(currentQuantityVal >= 1) {
        //     console.log($(this), $(this).attr("class").split(' '), $(this).hasClass("js-icon-quantity--cart"), ">1 +");
            
            // updatedQuantityVal = currentQuantityVal + 1;
            // $(this).closest("span").siblings(".product-page__quantity-input").val(updatedQuantityVal);
            // if($(this).hasClass("js-icon-quantity--cart")) {
            //     console.log('submiteee');
            //     $(this).closest('form').submit();
                
            // }  
        // }
        // console.log(currentQuantityVal, updatedQuantityVal)
    }
    else if($(this).hasClass("js-icon-minus-product")) {
        count = count - 1;
        $('#Quantity_product').val(count);
        // if(currentQuantityVal > 1) {
        //     console.log('minus', currentQuantityVal);
            // updatedQuantityVal = currentQuantityVal - 1;
        //     console.log($(this), $(this).attr("class").split(' '), $(this).hasClass("js-icon-quantity--cart"), ">1 -");
            // $(this).closest("span").siblings(".product-page__quantity-input").val(updatedQuantityVal); 
        //     if($(this).hasClass("js-icon-quantity--cart")) {
        //         console.log('submiteee');
        //         $(this).closest('form').submit();
                
        //     }
        // }
        // console.log(currentQuantityVal, updatedQuantityVal, "minus clicked")
    }
});


$('.js-add-to-cart').on('click',function(){
    var quantity_value = $('#Quantity_product').val();
    if(this.hasAttribute('data-variant-id')){
        variant_id = $(this).attr('data-variant-id');
    }

    var dis_quantity_value = $('#dis_quantity_product').val();
    if(this.hasAttribute('dis-product-id')){
        variant_dis_id = $(this).attr('dis-product-id');
        console.log('hhiiiiiiii',variant_dis_id)
    }

    if($(this).find('span').hasClass('span-text')) {
        $(this).find('span').css({'visibility':"hidden"});
        $(this).find('.load-3p').css({"display":"block"});
        window.location.href = '/cart';
    } else {
        $(this).find('span').addClass('span-text');
        $(this).find('span').html('go to cart <i class="fa fa-long-arrow-right arrow1" aria-hidden="true"></i>');
        // if(quantity_value<=$('#Quantity_product').attr('max')){
            $.ajax({
                url:"/cart/add ",
                type:"POST",
                dataType: "json",

                data:{
                    quantity: quantity_value,
                    id: variant_id
                },
                success:function(response) {
                    if (DISCOUNTED ) {
                        $.ajax({
                            url:"/cart/add ",
                            type:"POST",
                            dataType: "json",
                            data:{
                                quantity: dis_quantity_value,
                                id: DISCOUNTEDPRODUCT
                            },
                            success:function(response) {
                                $("#success_ajax_cart li").html('');
                                $("#success_ajax_cart li").html('Item added to your bag | <a href="/cart">View Cart</a>');
                                $("#success_ajax_cart").show();
                                setTimeout(function() {
                                    $("#success_ajax_cart").hide();
                                }, 7000);
                                $.getJSON('/cart/update.js', function(cart) { 
                                    console.log(cart.item_count);
                                    $(".num_count").each(function(){
                                        $(this).html(cart.item_count ); 
                                    });
                                });
                            },
                            error:function(err){
                                console.log(err);
                            }
                        });
                    }
                    else {
                        $("#success_ajax_cart li").html('');
                        $("#success_ajax_cart li").html('Item added to your bag | <a href="/cart">View Cart</a>');
                        $("#success_ajax_cart").show();
                        setTimeout(function() {
                            $("#success_ajax_cart").hide();
                        }, 7000);
                        $.getJSON('/cart/update.js', function(cart) { 
                            console.log(cart.item_count);
                            $(".num_count").each(function(){
                                $(this).html(cart.item_count ); 
                            });
                        });
                    }
                },
                error:function(err){
                    console.log(err);
                }
            });
        // }
    }
});

// $('.js-add-to-cart-single').on('click',function(){
//     var var_id = $(this).attr('data-variant-id');
//     console.log(var_id);
//     setTimeout(function () {
//         $.ajax({
//             url:"/cart/add ",
//             type:"POST",
//             dataType: "json",
    
//             data:{
//                 quantity: 1,
//                 id:  var_id
//             },
//             success:function(response) {
//                 console.log(response);
//                     window.location.href = '/cart';
//                     console.log(var_id);
//             },
//             error:function(err){
//                 console.log(err);
//             }
//         });
//     },500);
// });

$('.js-home-banner-carousel').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    autoplay:false,
    infinite: false,
    prevArrow:'<button type="button" class="slick-arrow slick-arrow--prev-men pull-left"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="32.092" height="62.771" viewBox="0 0 32.092 62.771"><path id="Path_6971" data-name="Path 6971" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(8569.738 5453.231) rotate(180)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    nextArrow:'<button type="button" class="slick-arrow slick-arrow--next-men pull-right"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="32.092" height="62.771" viewBox="0 0 32.092 62.771"><path id="Path_6472" data-name="Path 6472" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(-8537.646 -5390.46)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
});

$('.js-home-banner-carousel-mobile').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    autoplay:false,
});


$('.js-product-play-btn').magnificPopup({
    type: 'iframe',
    iframe: {
        markup: '<div class="mfp-iframe-scaler">' +
            '<div class="mfp-close"></div>' +
            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
            '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

        patterns: {
            youtube: {
                index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                id: 'v=', // String that splits URL in a two parts, second part should be %id%
                // Or null - full URL will be returned
                // Or a function that should return %id%, for example:
                // id: function(url) { return 'parsed id'; }

                src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
            },
            vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: '//player.vimeo.com/video/%id%?autoplay=1'
            },
            gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed'
            }

            // you may add here more sources

        },

        srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
    }
});

$(".product-heading-tab .product-link-skin-care").on("click", function() {
    $(".product-link-skin-care").removeClass("active");
    $(this).addClass("active");
    let clickedTabIndex = $(this).index();
    console.log(clickedTabIndex);
    $(".product-link-skin-care-link-details").removeClass("active");
    $(".product-link-skin-care-link-details").eq(clickedTabIndex).addClass("active");
    console.log('this is reaching here');
});

$('.shop-by-carousel-container').hover(
    function(){
        $(this).find('.shop-by-carousel-text-container').css({"bottom": "35px"});
        $(this).find('.carousel-product-heading').css({"margin-bottom": "11px"});
        $(this).find('.carousel-product-description-empty').css({"height": "0px"});
        $(this).find('.carousel-product-description').css({"padding-top": "0px"});
    },
    function(){
        $(this).find('.shop-by-carousel-text-container').css({"bottom": "-120px"});
        $(this).find('.carousel-product-heading').css({"margin-bottom": "35px"});
        $(this).find('.carousel-product-description-empty').css({"height": "45px"});
        $(this).find('.carousel-product-description').css({"padding-top": "25px"});
    }
);

$('.bags-image-container-mobile').each(function(index){
    // // $('.bags-image-container-mobile').attr('class').split(' ');
    // var a = $(this).attr('class').split(' ')[1];
    // if((index + 1)%4 == 0){
    //     console.log('in '+index);
    //     console.log($(this).attr('class').split(' ')[1]);
    //     // $(this).wrapAll( "<div class='carousel-test-container' />");
    // }
    // else{
    //     console.log('out '+index);
    //     $('.carousel-bags-container').append($(this));
    // }
    // // var a = $(this).attr('class').split(' ')[1];
    // // console.log($('.'+a));
    // // $('.'+a).each(function(){
    // //     console.log('i guess this is working');
    // // });
    // // console.log($(this).attr('class').split(' ')[1]);
});

// $('.carousel-test').wrapAll( "<div class='carousel-test-container' />");

// $('.carousel-test-container').slick();

$('.tablet-navigation-child-links').on('click', function(){
    let link = $(this).find('.hamburger-dropdown-link-text').attr('linkTo')
    if (link && link != '#') {
        window.location = window.location.origin + link;
    }
});

$('.tablet-navigation-child2-links').on('click', function(){
    let link = $(this).find('.hamburger-dropdown-link-text').attr('linkTo')
    if (link && link != '#') {
        window.location = window.location.origin + link;
    }
});

$(document).ready(function(){
    $('[data-toggle="tooltip"]').tooltip();   
  });

// $('.need-help').on('click',function(){
//     // $('.crisp-kquevr').trigger('click');
//     $('.crisp-kquevr').attr('data-maximized','true');
//     $('.crisp-ewasyx').attr('data-visible','true');
// });

// $('.crisp-1ekhg1c').on('click',function(){
//     $('.crisp-kquevr').attr('data-maximized','false');
//     $('.crisp-ewasyx').attr('data-visible','false');
//     $('.crisp-ewasyx').remove();
//     console.log('reaching here for chat box');
// });

$('#footer-newsletter').on('submit',function(e){
    // e.preventDefault();
    // console.log('this is newsletter');
    // $.ajax({
    //     url:"https://www.elevatione.com/contact%5Btags%5D=newsletter&form_type=customer",
    //     type:"GET",
    //     dataType: "json",

    //     data:{
    //         email: $('.newsletter-input').val()
    //     },
    //     success:function(response) {
    //         document.getElementById('successMessageSignupUl').getElementsByTagName('li')[0].innerHTML = "Congratulations! You have successfully subscribed to our newsletter!"
    //         window.addEventListener('load', function() {
    //             // $("#headerUl").css({'cssText': 'display: none !important'});
    //             // $("#myLoginModal").modal('hide');
    //             $("#successMessageSignupUl").css({'cssText': 'display: block !important'});
                
    //         });
    //     },
    //     error:function(err){
    //         document.getElementById('errorMessageSignupUl').getElementsByTagName('li')[0].innerHTML = "Please enter a valid email address to subscribe."
    //         window.addEventListener('load', function() {
    //             // $("#headerUl").css({'cssText': 'display: none !important'});
    //             // $("#myLoginModal").modal('hide');
    //             $("#errorMessageSignupUl").css({'cssText': 'display: block !important'});
                
    //         });
    //     }
    // });
});

$('.single-image-container').hover( 
    function(){
    //    $(this).find('p').css({"fontSize":"24px"});
    //    $(this).find('img').css({"transform":"scale(1.5)"});
       $(this).find('.custom-image-div').removeClass('custom-image-div-overlay');
       $(this).find('.custom-image-div').addClass('custom-image-div-overlay-hover');
    },
    function(){
        // $(this).find('p').css({"fontSize":"20px"});
        // $(this).find('img').css({"transform":"scale(1)"});
        $(this).find('.custom-image-div').addClass('custom-image-div-overlay');
        $(this).find('.custom-image-div').removeClass('custom-image-div-overlay-hover');
    }
); 
